import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {footerLinks} from "../../../common/util/uiConfigs/footerConfiguration";
import logo from "../../../common/media/cc_logo_grey.svg";


const FooterSection = ({}) => {

    return (
        <div className="w-100 py-3 font-etihad footer translate-dynamic">
            <div className="etihad-container py-5">
                <p className='m-0'><b>Powered by</b></p>
                <div className="d-flex border-bottom pb-3">
                    <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                        <img style={{ height: 24 }} className="footer-logo" src={logo} alt="carbonclick" />
                    </a>
                </div>

                <div className="row py-4">
                    <div className="col-4">
                        <div className="mb-3"><a className="color-inherit" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                        <div><a className="color-inherit" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                    </div>
                    <div className="col-4">
                        <div className="mb-3"><a className="color-inherit" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                        <div><a className="color-inherit" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                    </div>
                    <div className="col-4">
                        <div className="mb-3"><a className="color-inherit" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                        <div><a className="color-inherit" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                    </div>
                </div>

                <div className="center py-2 border-top border-bottom py-3">
                    <a href={footerLinks?.linkedin} target="_blank" rel="noopener noreferrer">
                        <img style={{ width: 30 }} src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,c_scale,w_40/v1664263895/Enterprise/Etihad/LinkedIn_hzbbc9.svg' alt="LinkedIn" />
                    </a>
                    <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                        <img style={{ width: 30 }} className='mx-3' src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,c_scale,w_40/v1663942613/Enterprise/Etihad/Atom__Icon__Social_icon__Instagram_cubatl.png' alt="instagram" />
                    </a>
                    <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                        <img style={{ width: 30 }} src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,c_scale,w_40/v1663942640/Enterprise/Etihad/Atom__Icon__Social_icon__Twitter_aqlude.png' alt="twitter" />
                    </a>
                </div>

                <div className='mt-4' style={{ textAlign: 'right' }}>
                    <div>
                        <img className='footer-logo' src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,c_scale,h_55/v1663941055/Enterprise/Etihad/From_Abu_Dhabi_for_the_World_zh1y5e.png' />
                    </div>
                    <p>Copyright 2024 Etihad Airways. All rights reserved</p>
                </div>
            </div>
        </div>
    )
}


export default FooterSection;